module.exports = __webpack_public_path__ + "static/media/unFocused.6b646cda.svg";